<template>
  <div id="app">
    <router-view :key="key"/>
  </div>
</template>

<script>
  export default {
    name: "App",
    computed: {
      key(){
        return this.$route.name?this.$route.name+new Date():this.$route.name+new Date();
      }
    },
    created() {
      localStorage.setItem('visit','0')
    }
  };
</script>

<style>
  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    margin: 0;
    padding: 0;
    background: #f5f5f5;
  }

  #mainPage {
    padding: 76px 0 0px 0;
  }

  .el-message {
    margin-top: 10%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue